var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactDoodles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1154,
    height: 795,
    viewBox: "0 0 1154 795",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72367 456.274C9.49114 444.055 15.8881 427.673 32.6123 432.154C40.5593 434.283 46.7344 446.129 46.2487 453.662C45.8457 459.909 47.5811 467.8 41.1332 471.69C36.0686 474.746 29.6683 474.312 25.6745 469.582C14.3328 456.149 35.2904 446.737 45.6826 448.792C59.8673 451.597 76.3042 486.937 63.9494 498.098C53.3564 507.668 46.3867 492.982 53.7858 484.272C64.1942 472.019 73.7683 471.63 85.8718 484.735C95.3223 494.968 92.4801 513.028 84.8549 522.529C83.2712 524.503 77.3438 538.315 75.9126 536.93C61.7901 523.266 86.81 503.134 100.713 505.996C116.687 509.285 132.813 512.795 143.371 525.439C149.049 532.238 159.529 556.563 157.515 547.936C154.995 537.141 152.576 522.327 157.05 511.575C158.382 508.376 162.386 498.057 159.005 508.073C155.523 518.389 152.216 527.394 150.799 537.637C150.484 539.916 153.446 543.15 154.457 545.083C155.313 546.721 148.649 544.617 147.853 544.534C140.977 543.82 134.693 546.468 128.802 549.759C123.544 552.697 117.526 558.21 113.561 556.25",
    stroke: "#00ADB5",
    strokeOpacity: 0.2,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.24 750.397C1097.2 746.281 1105.32 740.898 1112.43 735.394C1116.24 732.449 1120.34 729.923 1124.03 726.875C1124.54 726.445 1125.82 724.419 1126.59 725.083C1127.81 726.131 1128.99 727.95 1129.74 729.366C1131.9 733.479 1134.88 737.606 1137.94 741.069C1140.36 743.817 1142.33 746.137 1144.18 749.33C1145.18 751.076 1147.69 753.459 1147.51 755.4C1147.01 760.813 1141.95 765.826 1138.48 769.367C1133.38 774.57 1128.38 779.8 1122.32 783.799C1118.55 786.28 1114.31 787.59 1110.46 789.811C1106.92 791.857 1107.21 791.583 1103.84 788.609C1100.51 785.68 1098.45 782.502 1096.2 778.595C1095.02 776.562 1092.92 774.806 1091.29 773.125C1090.06 771.853 1089.61 769.68 1088.94 768.079C1088.24 766.399 1088.3 761.582 1086.77 760.579C1085.26 759.595 1083.52 757.434 1083.94 755.497C1084.29 753.916 1097.45 744.647 1086.46 754.994",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.05 757.941C1088.05 759.396 1090.96 761.485 1093.93 762.85C1094.91 763.304 1096.6 763.219 1097.39 763.84C1099.54 765.52 1105.76 764.5 1108.4 764.742C1111.38 765.016 1119.55 769.104 1120.64 764.079C1122.7 754.634 1125.01 745.231 1127.06 735.824C1127.44 734.047 1126.92 732.292 1127.27 730.669C1128.35 725.729 1123.61 728.846 1122.01 729.772",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M718.805 69.8232C736.977 61.2806 752.445 48.7889 767.904 36.9114C780.054 27.5763 792.727 18.2772 805.864 9.92429C808.456 8.2761 812.233 5.12037 815.313 5.94018C818.365 6.75256 819.774 9.73711 822.052 11.3428C827.662 15.2971 832.496 20.3555 836.88 25.2497C841.705 30.6374 832.748 34.9214 826.948 39.4521C820.361 44.5985 814.022 49.8548 806.957 54.5361C800.242 58.9859 794.545 64.7205 788.285 69.6078C778.743 77.0561 769.702 84.8607 760.184 92.3128C754.519 96.749 748.196 100.561 742.701 105.113C740.775 106.708 738.917 108.739 736.759 110.129C735.026 111.246 733.31 107.891 732.834 107.276C729.055 102.396 722.553 99.4961 718.903 94.3579C716.608 91.1273 715.341 86.965 712.454 84.1034C711.076 82.7373 707.577 79.7068 709.636 77.2552C711.738 74.7521 716.951 73.0818 719.941 71.123C722.271 69.596 725.107 67.7154 727.68 66.5469C729.549 65.6978 731.457 64.3502 733.171 63.2848C737.684 60.4809 733.108 61.9759 730.154 63.1607",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M719.968 80.1045C729.743 84.1576 738.11 90.6701 745.27 97.2152C745.451 97.381 747.291 98.276 746.929 98.7241C746.23 99.5891 739.916 96.7445 739.315 96.456",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M731.432 71.3787C739.673 72.3862 744.228 75.5492 750.547 78.7716C753.362 80.207 756.258 81.4626 758.715 83.246C759.869 84.0834 760.608 85.2736 761.653 86.199C763.086 87.4673 756.848 85.0785 756.112 84.8053",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M744.621 64.1323C749.977 67.7902 755.373 71.3848 760.941 74.8479C763.056 76.1635 765.505 77.3141 767.262 78.9457C770.383 81.8422 766.291 78.0885 764.867 77.059",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M753.544 59.0745C757.662 60.7406 761.987 62.3179 765.324 64.813C766.693 65.8364 767.77 67.1028 769.257 68.0264C771.089 69.1641 772.639 70.5573 774.489 71.6553C777.125 73.219 777.484 73.7215 774.371 71.7372",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M765.19 51.5229C769.638 54.046 773.717 56.6574 777.273 59.9448C778.848 61.4007 780.037 63.1519 782.152 64.1673C784.089 65.0977 785.514 65.2696 783.32 63.6509",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M776.452 43.8948C780.384 46.0086 784.287 47.9032 787.251 50.861C788.608 52.215 789.603 53.8345 791.159 55.0492C794.321 57.5159 792.073 56.3456 789.769 54.6892",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M786.942 36.1138C792.324 40.0764 796.616 44.9429 802.016 48.8474C805.653 51.4765 800.515 47.1864 799.685 46.415",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M799.353 29.4719C804.659 27.2377 810.198 24.6625 813.492 20.286C814.4 19.0791 815.504 17.9934 815.99 16.6936C816.656 14.9086 816.469 15.6632 814.711 16.9669",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M806.742 34.1607C811.182 30.7083 816.135 26.9257 819.613 22.785C821.348 20.7198 824.471 18.0862 820.173 21.2737",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M818.76 39.0088C822.871 35.3953 826.547 32.0511 830.387 28.324C831.627 27.1198 835.143 25.3438 831.029 26.6498",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M816.07 37.7167C820.275 34.6433 825.041 31.0793 828.546 27.4005C829.481 26.4192 830.243 25.3573 831.114 24.3488C832.574 22.6596 832.58 23.1741 830.671 23.5446",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M729.581 84.2856C749.561 75.9016 756.636 58.4278 773.545 47.1003C775.601 45.7223 777.321 44.2541 779.642 43.1998C781.195 42.4947 783.055 42.0322 784.496 41.1911C785.375 40.678 792.769 35.7301 787.795 37.9892",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M721.314 80.7503C723.75 78.4127 725.904 76.4044 728.836 74.5827C729.317 74.284 730.012 74.1649 730.425 73.7915C731.244 73.0518 732.479 71.966 732.877 71.0856C734.447 67.6181 739.752 67.6326 742.849 65.6353C745.795 63.7352 748.642 61.8269 751.638 59.94C754.939 57.8612 756.566 56.1801 759.333 53.6802C761.875 51.3839 764.353 49.0714 767.012 46.8692C769.186 45.0676 772.458 43.2843 773.984 41.1193C775.706 38.6759 779.659 35.6575 782.829 35.7196C783.918 35.7409 791.54 38.627 786.551 36.7946",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M737.469 86.9875C752.678 79.2866 762.498 65.1106 773.595 53.99C777.682 49.894 783.13 46.8662 787.376 42.8158C789.191 41.0833 792.954 39.0378 788.842 39.5245",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M742.073 90.1758C755.982 82.2843 765.981 69.3801 776.769 58.8332C781.677 54.035 786.448 49.163 791.404 44.394C793.664 42.2197 797.3 40.6124 792.574 43.1088",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M746.264 96.3165C755.271 89.0384 762.783 81.4317 770.453 73.3207C775.117 68.3888 779.31 62.9625 784.616 58.3979C787.66 55.7789 790.133 52.8344 792.945 50.1042C794.078 49.0044 794.926 47.7759 796.085 46.6812C798.697 44.2154 796.812 46.3927 795.041 47.77",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M747.785 98.8937C752.27 95.2575 758.617 91.5302 761.888 87.0985C763.075 85.4895 766.001 81.5983 767.828 80.4906C770.242 79.0264 771.671 76.3264 773.531 74.5207C775.468 72.6404 777.364 70.8048 779.434 68.9908C781.376 67.2897 782.299 64.5824 784.623 63.0453C787.212 61.3329 788.686 58.9662 790.831 57.0279C792.688 55.3502 796.042 53.4517 798.246 52.0821C799.468 51.3233 800.379 50.3733 801.73 49.7598C804.468 48.5163 802.709 49.1928 800.334 49.3882",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M798.86 30.7014C802.104 31.0359 806.158 31.0611 809 32.1851C810.834 32.9105 812.414 33.6682 809.074 32.3472",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M802.957 25.8247C807.586 26.2927 810.799 27.0385 814.404 28.6421C816.761 29.6906 816.404 29.3671 813.934 28.3805",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M809.37 20.6492C813.207 22.0428 816.887 23.7028 820.896 24.8413C823.255 25.5108 821.957 25.5909 820.139 25.0597",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M813.17 16.6614C817.256 17.756 821.006 18.8817 824.694 20.4212C826.376 21.1233 824.727 21.3655 823.458 20.7871",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M801.191 28.8885C804.877 25.4137 808.551 22.1008 811.957 18.5808C812.924 17.5808 818.752 11.9634 816.177 14.7927",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M803.849 33.9664C808.5 30.4829 815.159 25.7873 817.151 21.1381C817.737 19.7698 818.793 18.3497 820.198 17.2964C821.622 16.2281 823.035 15.6595 820.883 17.4322",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M800.468 34.2446C805.526 29.8296 809.749 26.7699 812.969 21.6683C813.805 20.3434 814.709 19.2217 815.933 18.1157C817.23 16.9437 819.02 15.7817 816.535 17.898",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M816.969 34.2922C818.9 35.1192 820.847 35.8679 822.884 36.5079C823.725 36.7722 822.72 36.1909 822.357 36.1189",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M821.749 28.6025C821.876 28.6828 829.262 33.3983 827.988 32.3048",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M826.885 26.0178C828.493 27.2107 833.445 30.6714 831.678 29.6229",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M814.245 36.7861C817.544 34.2147 824.711 29.0492 826.795 25.431C827.616 24.0051 830.755 21.9395 827.771 24.1075",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M814.528 37.4113C814.787 37.5622 819.81 41.8712 821.363 39.3352C822.155 38.0408 823.187 36.3548 824.806 35.5089C827.647 34.0248 828.66 30.2392 831.539 28.9319C834.805 27.4487 834.78 25.5776 831.98 25.2265C830.879 25.0886 832.027 23.1859 830.827 23.4598C829.728 23.7105 829.2 23.4536 827.966 23.7672",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M798.576 30.0765C800.116 32.8683 800.334 33.9186 803.321 34.8204C804.127 35.0638 805.306 34.469 805.917 34.6609C807.125 35.0406 809.656 34.7679 810.745 33.7112C812.934 31.5864 813.813 30.2748 816.922 28.7833C818.883 27.8424 820.618 25.9461 821.678 24.4166C822.843 22.7357 824.711 21.3581 825.929 19.6652C826.448 18.9444 823.259 17.5945 823.39 16.4332C823.427 16.1039 819.355 16.5502 818.716 16.3493C817.941 16.106 817.631 15.6756 817.334 15.0218C816.9 14.067 815.703 15.4469 814.143 15.7167",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M725.409 75.8735C729.84 76.77 733.621 78.1421 737.507 79.6943C740.88 81.0419 744.838 81.518 748.196 82.8143C750.586 83.7372 752.857 86.2009 754.493 87.8029C755.038 88.3366 755.429 88.8494 755.781 89.4805C756.587 90.9282 756.048 87.2703 755.997 86.8685",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M774.052 42.4707C775.184 43.4107 779.547 48.8115 779.148 44.4294",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactDoodles);
export default __webpack_public_path__ + "static/media/contact_doodles.0b887ccd45d69c225466151657b4a8fe.svg";
export { ForwardRef as ReactComponent };